/**
 * @file useNavAccordion.ts
 * @description Группы меню кабинета магазина — аккордеон (phase19.31,
 * замечание владельца: «при открытии раздела остальные сворачиваются»).
 *
 * Открыта одна группа. Открытие группы сворачивает остальные; повторное
 * нажатие на открытую группу её сворачивает (можно свернуть все). При
 * переходе на страницу (в том числе по прямой ссылке и после обновления)
 * открыта группа текущей страницы. Ничего не сохраняется между загрузками —
 * состояние всегда выводится из адреса и не «залипает».
 */

import { useCallback, useEffect, useState } from "react";

export interface NavAccordion {
  isOpen: (groupId: string) => boolean;
  toggle: (groupId: string) => void;
  /** Вернуть «открыта группа текущей страницы» (после очистки поиска). */
  reset: () => void;
}

export function useNavAccordion(activeGroupId: string | null, pathname: string): NavAccordion {
  const [openId, setOpenId] = useState<string | null>(activeGroupId);

  // Новая страница — открыта её группа, остальные свёрнуты.
  useEffect(() => {
    setOpenId(activeGroupId);
  }, [activeGroupId, pathname]);

  const isOpen = useCallback((groupId: string) => groupId === openId, [openId]);
  const toggle = useCallback((groupId: string) => {
    setOpenId((prev) => (prev === groupId ? null : groupId));
  }, []);
  const reset = useCallback(() => setOpenId(activeGroupId), [activeGroupId]);

  return { isOpen, toggle, reset };
}
